import React, { useState } from 'react';
import { T } from '../utils/theme';
import * as api from '../utils/api';
import { Btn, Modal } from './UI';

// One confirmation for disabling a discontinued product, wherever the button is (the product list, an
// item open in quoting). The server refuses while an order is with a supplier; that reason is shown here.
export default function DisableProductModal({ lang, products, productId, onClose, onDisabled, Lk }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const dp = products.find(p => p.id === productId);

  const close = () => { setErr(null); onClose(); };
  const doDisable = async () => {
    setBusy(true);
    setErr(null);
    try {
      await api.setDiscontinued(dp.id, true);
      await onDisabled(dp.id);
    } catch (e) {
      setErr(String(e.message || ''));
    } finally { setBusy(false); }
  };

  return (
    <Modal open={productId != null} onClose={close}>
      {dp && (
        <div>
          <h3 style={{ margin: '0 0 10px', fontSize: 17, fontWeight: 800, color: T.text }}>{lang === 'zh' ? `停用「${dp.name}」？` : `Disable “${dp.name}”?`}</h3>
          <p style={{ margin: '0 0 18px', fontSize: 13, color: T.muted, lineHeight: 1.5 }}>
            {lang === 'zh'
              ? '用于已停产的产品。它会离开报价和订购，供应商将不再看到它。历史订单保留，随时可以在「产品」中重新启用。'
              : 'For a product that is discontinued. It leaves Quoting and Ordering and suppliers stop seeing it. Its order history stays, and you can enable it again any time from Products.'}
          </p>
          {err && <div style={{ marginBottom: 14, padding: '8px 10px', borderRadius: 6, background: T.danger + '15', color: T.danger, fontSize: 12, fontWeight: 600 }}>{err}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <Btn onClick={doDisable} style={{ flex: 1 }} disabled={busy}>{lang === 'zh' ? '停用' : 'Disable'}</Btn>
            <Btn variant="ghost" onClick={close} style={{ flex: 1 }}>{Lk('cancel')}</Btn>
          </div>
        </div>
      )}
    </Modal>
  );
}
